import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthProvider';
import api from '../api.js';

const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
  const [permissions, setPermissions] = useState(new Map());
  const [loading, setLoading] = useState(true);

  const { user } = useAuth();

  const fetchPermissions = async () => {
    if (!user) {
      setLoading(false);
      return;
    }
    try {
      const response = await api.get('/roles/my-permissions');
      // Convert array to Map
      const map = new Map(response.data.map(p => [p.code, p]));
      setPermissions(map);
    } catch (error) {
      console.error('Erreur lors de la récupération des permissions:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPermissions();
  }, [user]);

  const hasPermission = (permissionCode) => {
    const p = permissions.get(permissionCode);
    return p ? p.granted : false;
  };

  return (
    <PermissionsContext.Provider value={{ permissions, hasPermission, loading, refetch: fetchPermissions }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionsContext);
